import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useHideOnScroll from '../../hooks/useHideOnScroll'
import LanguageSwitcher from '../LanguageSwitcher'
import { track } from './landingUtils'

const LandingHeader = () => {
    const { t } = useTranslation()
    const hidden = useHideOnScroll()

    return (
        <header className={`arcana-nav ${hidden ? 'is-hidden' : ''}`}>
            <div className="arcana-nav__inner">
                <Link to="/" className="arcana-nav__brand" aria-label={t('public.nav.home')}>
                    <span className="arcana-nav__mark" aria-hidden="true" />
                    askarkana
                </Link>

                <nav className="arcana-nav__actions">
                    <LanguageSwitcher inline />
                    <Link to="/login" className="arcana-nav__signin">
                        {t('public.nav.signIn')}
                    </Link>
                    <Link
                        to="/register"
                        className="arcana-btn arcana-btn--small"
                        onClick={() => track('cta_click', { where: 'nav' })}
                    >
                        {t('public.nav.getStarted')}
                    </Link>
                </nav>
            </div>
        </header>
    )
}

export default LandingHeader
